import { Component, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { StepperStepStatusConstant } from './../../shared/constants';

@Component({
    selector: 'app-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StepperComponent implements OnInit {

  @Input() dataSource = [];
  stepperStepStatusConstant = StepperStepStatusConstant;
  constructor() { }

  ngOnInit(): void {
  }
}
